export const FETCH_ORG_ACCESS_DATA_REQUEST="FETCH_ORG_ACCESS_DATA_REQUEST";
export const FETCH_ORG_ACCESS_DATA_SUCCESS="FETCH_ORG_ACCESS_DATA_SUCCESS";

export const UPDATE_ORG_ACCESS_DATA_REQUEST="UPDATE_ORG_ACCESS_DATA_REQUEST";
export const UPDATE_ORG_ACCESS_DATA_SUCCESS="UPDATE_ORG_ACCESS_DATA_SUCCESS";
